module.exports = __webpack_public_path__ + "static/media/D546GriffinStNW_2018-06-05_19.e0982488.jpg";